<table class="table table-hover" *ngIf="solicitacoes&&solicitacoes?.length;else carregando">
  <thead>
    <tr>
      <th scope="col">ID.</th>
      <th scope="col">Janela</th>
      <th scope="col">Parc.inicial honra </th>
      <th scope="col">Valor estimado </th>
      <th scope="col">Estado</th>
    <tr>
  </thead>
  <tbody>
    <tr *ngFor="let solicitacao of solicitacoes">
      <!--<tr *ngFor="let solicitacao of solicitacoesHonra">-->
      <td>{{ solicitacao.id }}</td>
      <td>{{ solicitacao.nomeJanela}}</td>
      <td>{{ solicitacao.dataParcelaInicialASerHonrada | date: 'dd/MM/yyyy'}}</td>
      <td class="moeda">{{ solicitacao.valorEstimadoHonra | bnMask: 'MOEDA'}}</td>
      <td>{{ solicitacao.estado.nomeEstado }}</td>
      <td>
        <a [routerLink]="['/solicitacoes-honra', solicitacao.id]">
          <i class="fa fa-search" aria-hidden="true" placement="left-top" ngbTooltip="Visualizar detalhes"> </i>
        </a>
    </tr>
  </tbody>
</table>




<div class="alert alert-info" *ngIf="showMessage">
  Não foram encontradas solicitacoes para esta operacão.
</div>

<ng-template #carregando *ngIf="!showMessage">
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>